'use client';

import { useEffect } from 'react';

import {
  reportClientError,
  type ClientErrorLevel,
} from '@/lib/client/observability/client-error';

// OBS-02 — hook that fires a single client-error report from a route error
// boundary (doc 13 §4.3). Call it from a boundary's useEffect-equivalent:
//
//   useReportRouteError(error, { route: '/c', level: 'error' });
//
// It swallows errors and runs once per error object.

export function useReportRouteError(
  error: Error & { digest?: string } | undefined | null,
  options: { route: string; level?: ClientErrorLevel },
): void {
  useEffect(() => {
    if (!error) return;
    void reportClientError({
      route: options.route,
      message: error.message || 'Unhandled route error',
      stack: error.stack,
      level: options.level,
    });
  }, [error, options.route, options.level]);
}
